import { useMutation } from "react-query";
import {
  SetVehicleLicensePlateParams,
  setVehicleLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const setVehicleLicensePlateFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: SetVehicleLicensePlateParams;
}) => {
  return await setVehicleLicensePlate(rowVersion, params);
};

export function useSetVehicleLicensePlate() {
  return useMutation(setVehicleLicensePlateFn, {
    mutationKey: MUTATION_KEYS.setVehicleLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
